import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import type Document from 'modules/documents/store/models/Document'
import { download } from 'modules/notifications/lib/downloadFile'

interface Props {
  documents: Document[]
}

const Documents = ({ documents }: Props) => {
  return (
    <Box gap="s8">
      <Text.Normal weight="medium" size="200" color="grey1000">
        {i18n.t('dashboard.todo.approvals.general.files')}
      </Text.Normal>
      {documents.map((document) => {
        return (
          <Box
            width="full"
            flexDirection="row"
            key={document.id}
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
            borderRadius={{ all: 'abs008' }}
            padding="s16"
            alignItems="center"
            justifyContent="spaceBetween"
            gap="s24"
          >
            <Box overflowX="hidden" maxWidth="s300">
              <Text.Normal weight="medium" color="grey1000" ellipsis>
                {document.filename}
              </Text.Normal>
            </Box>
            {document.file ? (
              <Button.Router type="secondary" to={buildUrl(document.file)} iconName="download" />
            ) : (
              <Button
                type="secondary"
                onClick={() =>
                  download({ fullPath: String(document.url), filename: document.filename })
                }
                iconName="download"
              />
            )}
          </Box>
        )
      })}
    </Box>
  )
}

export default Documents
